// extracted by mini-css-extract-plugin
export var cancelButton = "_lp-5";
export var content = "_lp-3";
export var createButton = "_lp-6";
export var drawerContainer = "_lp-0";
export var footer = "_lp-2";
export var header = "_lp-1";
export var orderFormColumn = "_lp-4";